import React from "react";
import { connect } from "react-redux";
import { Hospitals } from "../../components/Hospitals";
import { DashboardHeader } from "../../components/Header";
import language from "../../language";

class HospitalsScreen extends React.Component {
  render() {
    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <DashboardHeader
              title={language[this.props.defaultLanguage].hospitals}
            />
            <Hospitals />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(HospitalsScreen);
